import styled from 'styled-components';
import { Typ33 } from '../Typ';
import Ico24 from '../Ico24';

export const ElementWrapper = styled.span`
  display: flex;
`;
export const Icon = styled(Ico24)`
  color: #90a4ae;
  margin-right: 8px;
`;
export const ButtonText = styled(Typ33)`
  color: #90a4ae;
`;
